"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatsLoader = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _featureToggles = require("@ori/feature-toggles");
var _fetching = require("@ori/fetching");
var _i18n = require("@ori/i18n");
var _webMessenger = require("@ori/web-messenger");
var _lodash = _interopRequireDefault(require("lodash.debounce"));
var _react = require("react");
var _ChatsLoaderQuery = require("../../queries/ChatsLoaderQuery");
var _removeLanguageFromPathname = require("../../utils/removeLanguageFromPathname");
var _ChatBot = require("../Spas/apps/ChatBot");
var _GenesysWidget = require("../Spas/apps/GenesysWidget");
var _ChatFeature = require("./ChatFeature");
var _useFetchLocalizations = require("./useFetchLocalizations");
var _jsxRuntime = require("react/jsx-runtime");
const ChatsLoader = ({
  environment,
  webMessengerProps
}) => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    graphQlUrl: graphqlUrl
  } = (0, _configurationManager.useServiceUrls)(['graphQl']);
  const {
    token,
    isAnonymousUser,
    customerId
  } = (0, _auth.useToken)();
  const [data, setData] = (0, _react.useState)(null);
  const {
    isFeatureEnabled
  } = (0, _featureToggles.useFeatureToggles)();
  const {
    data: localizations
  } = (0, _useFetchLocalizations.useFetchLocalizations)();
  const isGenesysEnabled = isFeatureEnabled(_ChatFeature.ChatFeature.UseGenesysWidget);
  const isChatbotEnabled = isFeatureEnabled(_ChatFeature.ChatFeature.UseNewBotChat);
  const isWebMessengerEnabled = isFeatureEnabled(_ChatFeature.ChatFeature.UseWebMessenger);
  const abortController = (0, _react.useRef)();
  const debouncedQuery = (0, _react.useRef)((0, _lodash.default)((headers, isAuthenticated) => {
    const controller = new window.AbortController();
    abortController.current = controller;
    void (0, _fetching.fetchGraphql)({
      query: _ChatsLoaderQuery.ChatsLoaderQuery,
      variables: {
        includeChatbot: isChatbotEnabled,
        includeGenesys: isGenesysEnabled,
        isAuthenticated,
        pageUrl: (0, _removeLanguageFromPathname.removeLanguageFromPathname)(window.location.pathname, language)
      },
      url: graphqlUrl,
      headers
      /* TODO: pass signal: controller.signal when fetchGraphql support axios options */
    }).then(chatsData => {
      setData(chatsData);
    });
  }, 1000));
  const abortLatest = () => {
    if (abortController.current) {
      abortController.current.abort();
    }
  };
  (0, _react.useEffect)(() => {
    if (!isGenesysEnabled && !isChatbotEnabled || !token) {
      return;
    }
    abortLatest();
    debouncedQuery.current((0, _fetching.getHeaders)({
      tenant,
      language,
      token,
      customerId
    }), !isAnonymousUser);
  }, [token, isAnonymousUser, isChatbotEnabled, isGenesysEnabled, tenant, language, customerId]);
  if (!isGenesysEnabled && !isChatbotEnabled && !isWebMessengerEnabled || !token) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [isGenesysEnabled && localizations && data?.chat?.genesys?.configuration ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_GenesysWidget.GenesysWidget, {
      environment: environment,
      data: data,
      localizations: localizations
    }) : null, isChatbotEnabled && localizations && data?.chat?.chatBot?.configuration ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatBot.ChatBot, {
      environment: environment,
      data: data,
      localizations: localizations
    }) : null, isWebMessengerEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_webMessenger.WebMessengerController, {
      ...webMessengerProps
    }) : null]
  });
};
exports.ChatsLoader = ChatsLoader;
